import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class ContractCancellationReportService {
  constructor(private http: HttpUtilService) {}

  ContractCancellationReport(model: {
    FromDate: string;
    ToDate: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/ContractCancellationReport`,
      {
        model: model,
      },
    );
  }
}
